import { render, staticRenderFns } from "./qyFwpx.vue?vue&type=template&id=64edb734&"
import script from "./qyFwpx.vue?vue&type=script&lang=js&"
export * from "./qyFwpx.vue?vue&type=script&lang=js&"
import style0 from "./qyFwpx.vue?vue&type=style&index=0&lang=stylus&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports